export default (value: string): boolean => {
	const re = /^.{10,}$/;
	return re.test(value);
};
